import { render, staticRenderFns } from "./dPassword.vue?vue&type=template&id=856aa5bc&"
import script from "./dPassword.vue?vue&type=script&lang=js&"
export * from "./dPassword.vue?vue&type=script&lang=js&"
import style0 from "./dPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports